export default __webpack_public_path__ + "static/media/zoomarine-logo.6c4e6d85.png";